// extracted by mini-css-extract-plugin
export default {"container":"style_container__vtm5j","mobile":"style_mobile__+Qt-g","desktop":"style_desktop__But-A"};